import React from 'react';
import {
    Box,
    Text,
} from '@chakra-ui/react';

export function TextoInicioCv(){

    return(
        <>
            <Box filter="blur(4px)" mt={0} mb={5}>
                <Text ml={2}>
                    <strong>Próximo reto:</strong> Ingeniería Informática. Sin prisa.
                </Text>
            </Box>
        </>
    )
}
